import { useContext, useMemo } from "react";
import { AuthContext } from "context";
import { useStripeAccount } from "hooks/stripe";
import { Role } from "types/user";
import { getProviderProfileCompletionSummary, isProviderBankDetailsComplete, type ProfileCompletionSummary } from "./profileCompletion";

export function useProviderProfileCompletion(): ProfileCompletionSummary | null {
    const { account, currentRole } = useContext(AuthContext);
    const provider = account?.resources?.provider?.[0];
    const stripeAccountId = provider?.stripe_id;
    const { data: stripeAccount } = useStripeAccount(
        currentRole === Role.PROVIDER ? stripeAccountId : undefined
    );

    return useMemo(() => {
        if (currentRole !== Role.PROVIDER || !account) {
            return null;
        }

        return getProviderProfileCompletionSummary({
            pictureId: account.user.picture_id,
            identityVerified: account.user.dataleon_status === "approved",
            bankDetailsComplete: isProviderBankDetailsComplete(
                provider?.stripe_id,
                stripeAccount?.capabilities.transfers
            ),
            hasDescription: Boolean(provider?.description?.trim()),
            hasPhone: Boolean(account.user.phone?.trim()),
        });
    }, [
        account,
        currentRole,
        provider?.description,
        provider?.stripe_id,
        stripeAccount?.capabilities.transfers,
    ]);
}
